import EntityDirectoryPage from './EntityDirectoryPage'
import { customersApi } from '../../../shared/lib/api'

export default function PartiesPage() {
  return (
    <EntityDirectoryPage
      api={customersApi}
      entity={{
        singular: 'Party',
        plural: 'Parties / Customers',
        searchPlaceholder: 'Search parties or customers...',
        emailPlaceholder: 'party@email.com',
        exampleName: 'Arihant Exports',
        totalLabel: 'Total Sales',
        dateLabel: 'Last Sale',
      }}
    />
  )
}
